export class BootstrapHelperService{
    public isGoogleTagManagerLoaded:boolean = false;
    public PartnerHeaderLoadedCount: number = 0;
    public MainFooterLoadCount: number = 0;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/instrumentation/bootstrap-helper.service.ts